import {
  OPEN_PAYMENTS_ORIGIN_PARAM,
  OpenPaymentsOrigin,
} from '@/types/enums/analytics/open-payments/open-payments-analytics.enum';

export const OPEN_PAYMENTS_ROUTE = '/pagamentos-pendentes';

export function buildOpenPaymentsLink(origin: OpenPaymentsOrigin): string {
  return `${OPEN_PAYMENTS_ROUTE}?${OPEN_PAYMENTS_ORIGIN_PARAM}=${origin}`;
}
